import { Component, OnInit, Injector, Inject, Input, Output, EventEmitter } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { bodyWoSubmitReportControls } from '../../body-work-orders.template';

@Component({
  selector: 'body-wo-submit-report-assigned-form',
  templateUrl: './body-wo-submit-report-assigned-form.component.html',
  styleUrls: ['../../dialogs/body-wo-submit-report-dialog/body-wo-submit-report-dialog.component.css']
})
export class BodyWoSubmitReportAssignedFormComponent implements OnInit {
  @Input()
  set data(dataItem: any) {
    //this is kept empty on purpose
  }
  plannedCompletionDate: any;
  workOrderService: WorkOrdersService;

  constructor(private readonly injector: Injector) {
    this.workOrderService = this.injector.get(WorkOrdersService);
  }

  ngOnInit() {
    this.clearValidators();
  }

  clearValidators() {
    bodyWoSubmitReportControls.forEach(control => {
      this.workOrderService.bodyWoSubmitReportForm.get(control).clearValidators();
      this.workOrderService.bodyWoSubmitReportForm.get(control).updateValueAndValidity();
    });
  }
}
